export default __webpack_public_path__ + "static/media/Social Links.fe55e10f.svg";